import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { usePatient } from "../context/PatientContext";
import { useAuth } from "../context/AuthProvider";
import axios from "axios";
import AddNewCase from "./Add/AddNewCase";
import CONFIG from "../config";
import "../Styles/searchpatient.css";

const SelectPatientAndCases = () => {
  const { verifyTokenAndRedirect, user } = useAuth();
  const { patientData, setPatientData, selectedCase, setSelectedCase, doctorInfo } = usePatient();
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [patientCases, setPatientCases] = useState([]);
  const navigate = useNavigate();
  const baseURL = CONFIG.BASE_URL;
  const token = localStorage.getItem("authToken"); // or from context

  /**
   * 🔹 Ensure Authentication on Component Mount
   */
  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  /**
   * 🔹 Handle Searching for Patients
   */
  const handleSearch = useCallback(async (searchTerm) => {
    try {
 //     const response = await axios.get(`${baseURL}/patients/search-patients/${searchTerm}`, {doctorInfo});
   const response = await axios.get(`${baseURL}/patients/search-patients/${searchTerm}`, {
  headers: {
    Authorization: `Bearer ${token}`,        // 🔐 JWT Token
    doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
    clinicId: doctorInfo.CLINIC_ID,
    roleId: doctorInfo.MANDALI_ROLE
  }
});  
 
 setSearchResults(response.data);
 setIsSearching(true);
    } catch (error) {
      console.error("Error searching patients:", error);
      if (error.response && error.response.status === 404) {
        setSearchResults([]); // Set empty results for "No patients found"
      } else {
        // Handle other errors (e.g., network issues, 500 server errors)
        setSearchResults([]);
        console.error("Unexpected error:", error);
      }  
    }
  }, [baseURL, doctorInfo]);

  /**
   * 🔹 Handle Selecting a Patient
   */
  const handlePatientSelect = useCallback((patient) => {
    setPatientData(patient);
    navigate(`/patient/${patient.PATIENT_ID}`);
  }, [navigate, setPatientData]);

  // /**
  //  * 🔹 Handle Creating a New Patient
  //  */
  // const handleCreatePatient = async (patientData) => {
  //   const newPatient = await createNewPatient(patientData);
  //   if (newPatient) {
  //     setSelectedPatient(newPatient);
  //     alert("New Patient Created Successfully!");
  //   }
  // };

  /**
   * 🔹 Handle Creating a New Case
   */
  const handleCreateCase = useCallback(async () => {
    if (!patientData) return alert("Please select a patient first.");

    // const newCase = await createNewCase(patientData.PATIENT_ID);
    // if (newCase) {
    //   setSelectedCase(newCase.CASE_ID);
    //   setPatientCases([...patientCases, newCase]);
    //   alert("New Case Created Successfully!");
    // }

    const patientId = patientData.PATIENT_ID;

    try {
      const maxCaseId = patientCases.length > 0 ? Math.max(...patientCases.map((caseItem) => caseItem.CASE_ID)) : 0;
      const newCaseId = maxCaseId + 1;
      setSelectedCase(newCaseId);
      navigate(`/visits/${patientId}/${newCaseId}/addnewcase`);

    } catch (error) {
      console.error("Error creating new case:", error);
    } finally {
      //setLoading(false);
    }

  });

  return (
      <div className="container">
        <div className="search-section">
          <h2>Search Patients</h2>
          <PatientSearchBox onSearch={handleSearch} />
          
          {isSearching && (
          <>
          <h3>Search Results</h3>
          <table className="patient-table">
            <thead>
              <tr>
                <th>Patient ID</th>
                <th>Patient Name</th>
                <th>Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length > 0 ? (
                searchResults.map((patient) => (
                  <tr key={patient.PATIENT_ID} onClick={() => handlePatientSelect(patient)}>
                    <td>{patient.PATIENT_ID}</td>
                    <td>{patient.PATIENT_NAME}</td>
                    <td>{patient.PATIENT_PHONE}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="no-results">No patients found</td>
                </tr>
              )}
            </tbody>
          </table>
          </>
          )}
        </div>
        
      </div>
  );
};

/**
 * 🔹 Patient Search Box Component
 */
const PatientSearchBox = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="search-box">
      <input
        type="text"
        placeholder="Search patients by name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button onClick={() => onSearch(searchTerm)}>🔍</button>
    </div>
  );
};

/**
 * 🔹 Patient Case Select Component
 */
const PatientCaseSelect = ({ patientId, caseId }) => {
  const navigate = useNavigate();

  return (
    <div>
      <button onClick={() => navigate(`/visits/${patientId}/${caseId}`)}>View Visits</button>
    </div>
  );
};

export default SelectPatientAndCases;
